export default "__VITE_ASSET__XzUb5T$E__"